import { createSlice } from "@reduxjs/toolkit";
import { Env } from "utils/Types";
import { UI_ENVIRONMENT_KEY } from "utils/Constants";

type GlobalUISliceType = {
  successNotificationMsg?: string;
  afterTransferOwnership: boolean;
  env: Env | null;
  pendingEnv: Env | null;
};

const initialState: GlobalUISliceType = {
  afterTransferOwnership: false,
  successNotificationMsg: undefined,
  env: null,
  pendingEnv: null
};

export const isValidEnv = (env: string | null): env is Env => {
  return env === Env.DOMESTIC || env === Env.INTERNATIONAL;
};

export const GlobalUISlice = createSlice({
  name: "global-ui",
  initialState,
  reducers: {
    setAfterTransferOwnership: (state, { payload }) => {
      const { afterTransferOwnership, msg } = payload;
      state.successNotificationMsg = msg;
      state.afterTransferOwnership = afterTransferOwnership;
    },
    setEnv: (state, { payload }) => {
      localStorage.setItem(UI_ENVIRONMENT_KEY, payload);
      state.env = payload;
    },
    setPendingEnv: (state, { payload }) => {
      state.pendingEnv = payload;
    }
  }
});

export const { setAfterTransferOwnership, setEnv, setPendingEnv } = GlobalUISlice.actions;

export default GlobalUISlice.reducer;
